module.exports = __webpack_public_path__ + "static/media/PSIRF_alert_pale_green.0a192b25.png";